import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { factoryService, getFileRequest, getJsonRequest } from '@chilecompra/react-kit'
import { features } from '../config/settings/features'

/**
 * Gets a excel file to download with the quote search results
 */
export const getDownloadQuoteSearch = factoryService(({ queryString }) =>
  getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.excel'] ? 'compra-agil-excel' : 'compra-agil'
    }/buscar/excel?${queryString}`
  )
)

/**
 * Gets the quote search
 */
export const getQuoteSearch = factoryService(({ queryString }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.search'] ? 'compra-agil-busqueda' : 'compra-agil'
    }/buscar?${queryString}`
  )
)

/**
 * Gets seller notifications
 */
export const getSellerNotification = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/comprador/notificar/`)
)
